import { TableTemplateV2 } from "../dashboard/TableTemplate-v2";
import { TableWidget } from "./TableWidget";
import { translate } from "app/filters/i18nFilter";
import { tableColumns } from "app/components/keyword-research/website-search-ads/SearchAdsPageColumnsConfig";
import { transformAdsData } from "app/common/keyword-research/website-search-ads/adsDataUtils";
import PaidSearchAdsTableWidgetFilters from "../widget-filters/PaidSearchAdsTableWidgetFilters";
import type {
    IAdsTableServerData,
    IAdsTableServerResponse,
} from "app/common/keyword-research/website-search-ads/searchAdsPageTypes";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

const widgetTitleWebsourceToPrefixMap = new Map([
    [devicesTypes.DESKTOP, "Desktop"],
    [devicesTypes.MOBILE, "Mobile Web"],
]);

export class PaidSearchAdsTableWidget extends TableWidget {
    constructor() {
        super();
    }
    public isPptSupported = () => {
        return false;
    };

    static getWidgetDashboardType() {
        return "Table";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    static getWidgetMetadataType() {
        return "PaidSearchAdsTable";
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/table.html`;
    }

    get templateComponent() {
        return TableTemplateV2;
    }

    public initWidget(widgetConfig, context) {
        super.initWidget(widgetConfig, context);
        this.updateApiParams({
            key: widgetConfig.properties.key[0].name,
        });
    }
    getViewData() {
        super.getViewData();
        const titleFromMetricConfig = translate("dashboard.metrics.titles.search.ads");
        if (this.viewData.title.includes(titleFromMetricConfig)) {
            this.viewData.title = `${widgetTitleWebsourceToPrefixMap.get(
                this.apiParams.webSource,
            )} ${titleFromMetricConfig}`;
        }
        return this.viewData;
    }

    public getProUrl() {
        const { orderBy = "TrafficShare desc", IncludeTerms, ExcludeTerms } = this._params;
        const finalParams = { ...this._getProUrlParams(), orderBy, IncludeTerms, ExcludeTerms };
        return this._swNavigator.href(this._metricConfig.state, finalParams);
    }

    static getFiltersComponent() {
        return PaidSearchAdsTableWidgetFilters;
    }

    protected validateData(data: IAdsTableServerData[]) {
        return !!data?.length;
    }

    protected getMetricColumnsConfig() {
        const columns = this.filterColumnsForDashboard(tableColumns.getColumns()).map((column) => ({
            ...column,
            title: column.displayName,
            cellCls: `${column.cellClass} ${column.cellClass}-dashboard`,
        }));

        // remove the right aligning header so the header will be left aligned
        const volumeColumnIndex = columns.findIndex((column) => column.field === "Volume");
        delete columns[volumeColumnIndex].headerComponent;
        return columns;
    }

    public callbackOnGetData(response: IAdsTableServerResponse): void {
        if (response?.Data?.length) {
            response.Data.slice(0, 3);
        }
        const transformedData = transformAdsData("text", response);
        super.callbackOnGetData({
            Data: transformedData.data,
            TotalCount: transformedData.TotalCount,
        });
    }
}
PaidSearchAdsTableWidget.register();
